import { Directive, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[fi-ng-init]',
    standalone: false,
})
export class NgInitDirective implements OnInit {
    @Output('fi-ng-init') onInit = new EventEmitter<any>();

    constructor() {}

    ngOnInit(): void {
        this.onInit.emit();
    }
}
